import { render, staticRenderFns } from "./BagsChart.vue?vue&type=template&id=ed5e4e60"
import script from "./BagsChart.vue?vue&type=script&lang=js"
export * from "./BagsChart.vue?vue&type=script&lang=js"
import style0 from "./BagsChart.vue?vue&type=style&index=0&id=ed5e4e60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports